import { createApp } from "vue";
import GlobalNavigation from "./nav.vue";
import './index.scss';
import cyIcon from '../../components/icon.vue';
import cyButton from '../../components/button.vue';

const navigation = createApp(GlobalNavigation);
navigation.component('cy-icon', cyIcon);
navigation.component('cy-button', cyButton);
navigation.mount(document.getElementById("vue-theme-navigation"));